import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../buildStore';
import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
import { EVENT_NAMES } from '../../usage-tracking/constants/eventNames';
import { getIsAIChatbot } from '../../selectors/widgetDataSelectors/getIsAIChatbot';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { getIsPortal53 } from '../../widget-data/operators/getIsPortal53';
import { getConsentToProcessMessage } from '../selectors/getConsentToProcessMessage';
import { getShowGdprConsentToProcess } from '../selectors/getShowGdprConsentToProcess';
import { getConsentToProcessError } from '../selectors/getConsentToProcessError';
// @ts-expect-error untyped file
import { consentToProcess } from '../actions/visitorConsentsToProcess';
import { dismissConsentToProcessError } from '../actions/visitorDismissesConsentToProcessError';
import { closeConsentToProcess } from '../actions/visitorClosesConsentToProcess';
const useProcessConsentPrompt = () => {
  const dispatch = useAppDispatch();
  const isAIChatBot = useAppSelector(getIsAIChatbot);
  const widgetColoring = useAppSelector(getColoring);
  const isPortal53 = getIsPortal53();
  const consentToProcessMessage = useAppSelector(getConsentToProcessMessage);
  const showGdprConsentToProcessButton = useAppSelector(getShowGdprConsentToProcess);
  const consentToProcessError = useAppSelector(getConsentToProcessError);
  useEffect(() => {
    dispatch(trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
      action: 'view consent to process'
    }));
  }, [dispatch]);
  const handleConsentToProcess = () => {
    dispatch(consentToProcess());
  };
  const handleDismissConsentToProcessError = () => {
    dispatch(dismissConsentToProcessError());
  };
  const handleCloseConsentToProcess = () => {
    dispatch(closeConsentToProcess());
  };
  return {
    isAIChatBot,
    widgetColoring,
    isPortal53,
    consentToProcessMessage,
    showGdprConsentToProcessButton,
    consentToProcessError,
    handleConsentToProcess,
    handleDismissConsentToProcessError,
    handleCloseConsentToProcess
  };
};
export default useProcessConsentPrompt;